/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRadiationType } from 'app/shared/model/radiation-type.model';

export interface IRadiationBeamParameter {
  id?: string;
  name?: string | null;
  description?: string | null;
  value?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  radiationTypes?: IRadiationType[] | null;
}

export const defaultValue: Readonly<IRadiationBeamParameter> = {
  active: false,
};
